const SKILL_STATUS = {
  EXPIRED: 0,
  CLOSE_TO_EXPIRE: 1,
  NOT_EXPIRED: 2,
  PERMAMENT: 3,
};

export default SKILL_STATUS;
